import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import PricingPackages from './components/PricingPackages';
import WhyChoose from './components/WhyChoose';
import FAQ from './components/FAQ';
import EnterpriseSolutions from './components/EnterpriseSolutions';
import Footer from './components/Footer';
import AnimatedSection from './components/AnimatedSection';
import SEO from './components/SEO';
import FAQPage from './pages/FAQPage';
import LocationsPage from './pages/LocationsPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import RefundPage from './pages/RefundPage';
import HelpCenterPage from './pages/HelpCenterPage';
import ContactPage from './pages/ContactPage';
import APIReferencePage from './pages/APIReferencePage';
import DashboardLayout from './components/DashboardLayout';
import DashboardPage from './pages/DashboardPage';
import TopupsPage from './pages/TopupsPage';
import RotatingResidentialBasicPage from './pages/RotatingResidentialBasicPage';
import RotatingResidentialPremiumPage from './pages/RotatingResidentialPremiumPage';
import ProfilePage from './pages/ProfilePage';
import BandwidthPackagesPage from './pages/BandwidthPackagesPage';
import PackageDetailsPage from './pages/PackageDetailsPage';
import EarnPage from './pages/EarnPage';
import ProxyTesterPage from './pages/ProxyTesterPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import EmailConfirmedPage from './pages/EmailConfirmedPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import LinkDiscordPage from './pages/LinkDiscordPage';
import TicketsPage from './pages/TicketsPage';
import MonthlyResidentialPage from './pages/MonthlyResidentialPage';

const HomePage = () => (
  <>
    <SEO
      title={null}
      description="Premium rotating residential proxies with 40M+ ethically sourced IPs in 150+ countries. Pay-as-you-go from $0.40/GB. SOCKS5 & HTTP/HTTPS. 99.9% uptime. No KYC. Crypto accepted."
      path="/"
    />
    <Navbar />
    <Hero />
    <AnimatedSection>
      <Features />
    </AnimatedSection>
    <AnimatedSection>
      <PricingPackages />
    </AnimatedSection>
    <AnimatedSection>
      <WhyChoose />
    </AnimatedSection>
    <AnimatedSection>
      <EnterpriseSolutions />
    </AnimatedSection>
    <AnimatedSection>
      <FAQ />
    </AnimatedSection>
    <Footer />
  </>
);

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/locations" element={<LocationsPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/refund" element={<RefundPage />} />
            <Route path="/help" element={<HelpCenterPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/api" element={<APIReferencePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/email-confirmed" element={<EmailConfirmedPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/link-discord" element={<LinkDiscordPage />} />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="topups" element={<TopupsPage />} />
              <Route path="bandwidth" element={<BandwidthPackagesPage />} />
              <Route path="bandwidth/:packageId" element={<PackageDetailsPage />} />
              <Route path="subusers" element={<DashboardPage />} />
              <Route path="earn" element={<EarnPage />} />
              <Route path="rotating/monthly-residential" element={<MonthlyResidentialPage />} />
              <Route path="rotating/residential-basic" element={<RotatingResidentialBasicPage />} />
              <Route path="rotating/residential-premium" element={<RotatingResidentialPremiumPage />} />
              <Route path="rotating/isp" element={<DashboardPage />} />
              <Route path="rotating/datacenter" element={<DashboardPage />} />
              <Route path="rotating/traffic-logs" element={<DashboardPage />} />
              <Route path="tools/proxy-tester" element={<ProxyTesterPage />} />
              <Route path="servers" element={<DashboardPage />} />
              <Route path="tickets" element={<TicketsPage />} />
              <Route path="profile" element={<ProfilePage />} />
            </Route>
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
